import Immutable from "immutable";
import { CHARACTER_LIMIT } from "constants/messages";
import { removeTemplateVariables } from "services/strings";
import BaseMessageRecord, {
  BaseMessageRecordAttributes,
  BlockConfigGetter
} from "../BaseMessageRecord";

interface TextMessageRecordAttributes extends BaseMessageRecordAttributes {
  type: "text";
  body: string;
}

class TextMessageRecord extends BaseMessageRecord<TextMessageRecordAttributes>({
  type: "text",
  body: ""
}) {
  static blockConfig: BlockConfigGetter = () => ({
    isVisible: true,
    icon: "Text",
    blockName: "Text",
    blockTitle: "Text Message",
    shortTitle: "Text",
    blockType: "message"
  });

  static getInvalidFields = (message: TextMessageRecord): Immutable.List<string> => {
    const invalidFields: Set<string> = new Set();
    const bodyWithoutTemplateVars = removeTemplateVariables(message.body);

    if (
      message.body.trim().length <= 0 ||
      bodyWithoutTemplateVars.trim().length > CHARACTER_LIMIT
    ) {
      invalidFields.add("body");
    }

    return Immutable.List(invalidFields);
  };
}

export default TextMessageRecord;
